import axiosInstance from './axiosInstance';

export const getWishlistApi    = ()          => axiosInstance.get('/wishlist');
export const toggleWishlistApi = (productId) => axiosInstance.post(`/wishlist/${productId}`);
